/* eslint-disable */
import Betslip from '@om-retail/betslip';
import { toReactive } from '@om-retail/web-cmp';
import store from '../index';
import { defineStore } from 'pinia';
import dayjs from 'dayjs';

// eslint-disable-next-line import/prefer-default-export
export const useBetslipStore = defineStore('betslip', {
    betslip: null,
    state: () => ({
        betslipList: [],
        savedLottoNumbers: [],
        betslipSelectedNumbers: [],
        betslipSelectedOffers: [],
    }),
    getters: {
        betslipType(state)
        {
            if (!state.betslip)
            {
                return null;
            }
    
            let type = null;

            for (const item of state.betslip.items)
            {
                const itemType = (item.type === 'outrights' || item.type === 'betbuilder') ? 'sport' : item.type;
    
                if (type === null)
                {
                    type = itemType;
                }
                else if (type !== itemType)
                {
                    return 'mix';
                }
            }
    
            return type;
        },
    },
    actions: {
        getBetslip()
        {
            return this.betslip;
        },
        initBetslip(ticketConfig, playerdata)
        {
            if(this.betslip == null)
            {
                try {
                    const config = {
                        ...ticketConfig,
                    };
    
                    if (playerdata
                    && playerdata.money
                    && playerdata.money.currency
                    && config.activeTicketConfigWithCurrency)
                    {
                        const { currency } = playerdata.money;
    
                        if (config.activeTicketConfigWithCurrency[currency])
                        {
                            config.activeTicketConfig = config.activeTicketConfigWithCurrency[currency];
                        }
                    }

                    
                    this.betslip = new Betslip.Betslip({
                        ...config,
                        rawConfiguration: true,
                        globalRestrictions: store.getters.offerRestrictionsGlobal,
                    });
                    this.betslip = toReactive(this.betslip);
                    
                    this.betslip.setDeviceType('web');
    
                    if (window.webpackHotUpdate != null)
                    {
                        this.betslip.setDebugMode(true);
                    }
                }
                catch(e)
                {
                    console.error(e);
                }
            }
        },
        changeBetslipType(data)
        {
            if(this.betslip)
            {
                this.betslip.changeBetslipType(data);
            }
        },
        createBetslip(ticketConfig)
        {
            return new Betslip.Betslip({
                ...ticketConfig,
                rawConfiguration: true,
            });
        },
        // Remove betslip from betslip list in lotto draws component
        removeBetslip(betslip)
        {
            const temp = this.betslipList.filter((item) => String(item.drawId) !== String(betslip.drawId))
            this.betslipList = [...temp];
            this.betslipSelectedOffers = this.betslipList.map((item) => item.drawId);
        },
        async selectBetslipOutcome(item)
        {
            if (!this.betslip)
            {
                return;
            }

            if (item)
            {
                await this.betslip.addItem(item);
            }
        },
        async wipeAllBetslipData(params = {})
        {
            if (!this.betslip)
            {
                return;
            }

            await this.betslip.wipeBetslipData();
            if (!params || !params.skipSportWipe)
            {
                window.localStorage.removeItem('sport');
            }
            window.localStorage.removeItem('lottoNumbers');
            window.localStorage.removeItem('lastSelectedLottery');
            window.localStorage.removeItem('lottoCombinations');
            window.localStorage.removeItem('lotto');
            window.localStorage.removeItem('vhorse');
            window.localStorage.removeItem('betBuilderSelections');
            await this.betslip.recalculateBetslip();

            this.savedLottoNumbers = [];
            window.localStorage.setItem(
                'lottoNumbers',
                JSON.stringify(this.savedLottoNumbers),
            );
        },
        clearItems(type = null, clearPayin = false)
        {
            this.clearItemsInState({
                betslipType: this.betslipType,
                type,
                clearPayin,
            });
        },
        clearItemsInState(data)
        {
            const { betslipType, type, clearPayin } = data;

            if (this.betslip)
            {
                this.betslip.clearItems({
                    clearOtherThanType: type || null,
                    clearPayin,
                });

                if (!type && betslipType)
                {
                    window.localStorage.setItem(
                        betslipType,
                        JSON.stringify([]),
                    );
                }
            }
        },
    },
});
